// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-name {
    margin-top: 30px;
    font-size: 26px;
    font-weight: bold;
}
.sign {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.sign1, .sign2 {
    display: grid;
}
.sign2 {
    margin-left: 20em;
}
.sign2-admin {
    margin-left: 50em;
}
input {
    border: none;
    font-size: 18px;
}
.sign-label1, .sign-label2 {
    text-align: center; 
    font-size: 18px;
}
.sign-label-name {
    margin-left: 26px;
    font-size: 18px;
}
.today-date {
    text-align: center; 
    font-size: 18px;
}
.approve-at {
    margin-top: 50px;
    display: flex;
    justify-content: end;
}
.student-container {
    margin-top: 20px !important;
}
.term-condition {
    margin-top: 40px;
    margin-bottom: 10px;
    font-size: 18px;
}
.water-mark {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
}
.sign-container1 {
    width: 300px;
}
.sign-container2 {
    width: 400px;
}
@media print {
    .navbar { 
        display: none !important;
    }
}

.handle-page-btn {
    width: 100px;
}
.btn-container {
    display: flex;
    margin-left: 5px;
}
.print-btn {
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentCourse/Print/Print.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".course-name {\r\n    margin-top: 30px;\r\n    font-size: 26px;\r\n    font-weight: bold;\r\n}\r\n.sign {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 10px;\r\n}\r\n.sign1, .sign2 {\r\n    display: grid;\r\n}\r\n.sign2 {\r\n    margin-left: 20em;\r\n}\r\n.sign2-admin {\r\n    margin-left: 50em;\r\n}\r\ninput {\r\n    border: none;\r\n    font-size: 18px;\r\n}\r\n.sign-label1, .sign-label2 {\r\n    text-align: center; \r\n    font-size: 18px;\r\n}\r\n.sign-label-name {\r\n    margin-left: 26px;\r\n    font-size: 18px;\r\n}\r\n.today-date {\r\n    text-align: center; \r\n    font-size: 18px;\r\n}\r\n.approve-at {\r\n    margin-top: 50px;\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n.student-container {\r\n    margin-top: 20px !important;\r\n}\r\n.term-condition {\r\n    margin-top: 40px;\r\n    margin-bottom: 10px;\r\n    font-size: 18px;\r\n}\r\n.water-mark {\r\n    text-align: center;\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n}\r\n.sign-container1 {\r\n    width: 300px;\r\n}\r\n.sign-container2 {\r\n    width: 400px;\r\n}\r\n@media print {\r\n    .navbar { \r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.handle-page-btn {\r\n    width: 100px;\r\n}\r\n.btn-container {\r\n    display: flex;\r\n    margin-left: 5px;\r\n}\r\n.print-btn {\r\n    margin-left: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
